var React = require('react');

function DecorationMix3Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_267","data-name":"Group 267","transform":"translate(-1192.5 -3915.859)"},[React.createElement("path",{"id":"Polygon_2","data-name":"Polygon 2","d":"M46.127,0,92.253,104.617H0Z","transform":"translate(1224.053 4038.331) rotate(-110)","fill":"#ffda60","key":0}),React.createElement("path",{"id":"Polygon_3","data-name":"Polygon 3","d":"M48.5,0l48.5,75.134H0Z","transform":"matrix(-0.588, 0.809, -0.809, -0.588, 1340.784, 3995.493)","fill":"#ffda60","key":1})]));
}

DecorationMix3Inline.defaultProps = {"width":"148.284","height":"158.115","viewBox":"0 0 148.284 158.115"};

module.exports = DecorationMix3Inline;

DecorationMix3Inline.default = DecorationMix3Inline;
